import { IHttpService } from "../HttpService";
import { formatBooleanValue } from "../..";
import MenuItem, { IMenuItem } from "../../model/menu/MenuItem";
import { MenuItemInsertForm } from "../../common/Constants";

export interface IPortalMenuItemService {
  getAllMenuItems(languageCode: number): Promise<IMenuItem[]>;
}

const PortalMenuItemService = (httpService): IPortalMenuItemService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/codebooks";
  const _menuItemsPath = "menu-items";

  let MenuItemListMapper = (json = []) => {
    return json.map((item: any) => {
      let menuItem = MenuItem(item);
      menuItem.valid = formatBooleanValue(item.valid);
      return menuItem;
    });
  };

  function populateMenuItemChildren(
    menuItem: IMenuItem,
    menuItems: IMenuItem[]
  ) {
    const menuItemChildren = menuItems.filter(
      (item) => item.menuItemId === menuItem.id
    );
    menuItemChildren.sort((a, b) => {
      return a.rbr - b.rbr;
    });

    if (menuItemChildren && menuItemChildren.length > 0) {
      menuItem.children = menuItemChildren;

      menuItem.children.forEach((item) =>
        populateMenuItemChildren(item, menuItems)
      );
    }
  }

  return {
    async getAllMenuItems(languageCode: number) {
      const path = _http.buildPath(_baseUrl, _menuItemsPath);
      const response = await _http.get(path, {
        form: true,
        params: {
          aplModCode: MenuItemInsertForm.Constants.MIK_PUBLIC,
          languageCode
        }
      });
      const responseJSON = await _http.toJSON(response);
      let menuItems = MenuItemListMapper(responseJSON);

      let rootMenuItems = menuItems.filter((menuItem) => !menuItem.menuItemId);
      rootMenuItems.forEach((menuItem) =>
        populateMenuItemChildren(menuItem, menuItems)
      );

      return rootMenuItems;
    }
  };
};

export default PortalMenuItemService;
